import { render, staticRenderFns } from "./OverviewSection.vue?vue&type=template&id=4eb60fd9&scoped=true&"
import script from "./OverviewSection.vue?vue&type=script&lang=js&"
export * from "./OverviewSection.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSection.vue?vue&type=style&index=0&id=4eb60fd9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb60fd9",
  null
  
)

export default component.exports